// Libs
import React, { ReactElement } from 'react';
import { Autocomplete, Icon, ListItemIcon, Stack, TextField } from 'ui-components';
// App
import styles from './search.module.scss';
import { SearchProps } from './search.props';
import useShopSwitchSearch from './search.hook';
import { getShopName, isSameShop, keepClickInsideMenu, keepKeyInsideMenu } from './search.utils';

const Search = (props: SearchProps): ReactElement => {
  const { shopId } = props;
  const {
    currentShop,
    shopOptions,
    searchText,
    isListOpen,
    isSearchLoading,
    isSwitching,
    openList,
    closeList,
    keepOtherShops,
    handleInputChange,
    handleShopSelected,
  } = useShopSwitchSearch(shopId);

  return (
    <Stack
      direction="row"
      alignItems="center"
      className={styles.search}
      onClick={keepClickInsideMenu}
      onKeyDown={keepKeyInsideMenu}
    >
      <ListItemIcon>
        <Icon name="store" />
      </ListItemIcon>
      <Autocomplete
        id="shop-switch-autocomplete"
        multiple={false}
        data-testid="shop-switch-autocomplete"
        autoHighlight={true}
        disabled={isSwitching}
        open={isListOpen}
        onOpen={openList}
        onClose={closeList}
        value={currentShop}
        options={shopOptions}
        loading={isSearchLoading}
        filterOptions={keepOtherShops}
        getOptionLabel={getShopName}
        isOptionEqualToValue={isSameShop}
        inputValue={searchText}
        onInputChange={handleInputChange}
        onChange={handleShopSelected}
        renderInput={(params) => (
          <TextField
            className={styles.input}
            ref={params.InputProps.ref}
            placeholder="Nom du restaurant"
            inputProps={{ ...params.inputProps, 'aria-label': 'Changer de restaurant' }}
          />
        )}
      />
    </Stack>
  );
};

export default Search;
